<div>
  <fun-spinner *ngIf="loading"></fun-spinner>
  <div *ngIf="!loading">
    <div *ngIf="step === 0" class="w-full">
      <p class="text-xl text-eggplant-100/[0.55] text-center">Estas son las personas con mas de un 25% de la sociedad. ¿Es correcto?</p>
      <div class="p-16">
        <div class="pb-24" *ngFor="let partner of profile.partners">
          <p class="text-eggplant-100 text-left w-full">Nombre: {{ partner.name }} {{ partner.surname }}</p>
          <p class="text-eggplant-100 text-left w-full">Fecha de nacimiento: {{ partner.birthDate }}</p>
          <p class="text-eggplant-100 text-left w-full">Dirección: {{ partner.residenceAddress }}, {{ partner.residencePostalCode }}, {{ partner.residenceCity }} ({{ partner.residenceRegion }})</p>
        </div>
        <div class="flex flex-col md:flex-row gap-12 items-center justify-center w-full py-16">
          <fun-new-button
            [buttonType]="'primaryDark'"
            [size]="'xl'"
            title="La información es correcta"
            iconPosition="right"
            icon="check-circle"
            (eventClick)="getShareholderUrl()"
            [classExtra]="' w-auto mx-auto '"></fun-new-button>
          <fun-new-button
            [buttonType]="'secondaryDark'"
            [size]="'xl'"
            title="Editar informacion"
            iconPosition="right"
            icon="edit-3"
            (eventClick)="editPartnersInfo()"
            [classExtra]="' w-auto mx-auto '"></fun-new-button>
        </div>
      </div>
    </div>
    <div *ngIf="step === 1">
      <div *ngIf="lleidanetOpen"
        class="py-72 w-full flex flex-col gap-72 items-center justify-center content-center appear bg-white rounded-2xl">
        <div>
          <fun-icon *ngIf="!blockedWindow" [name]="'file-text'"
            [style]="'w-72 h-[86px] stroke-[4px] stroke-eggplant-70 animate-gradientX'"></fun-icon>
          <fun-icon *ngIf="blockedWindow" [name]="'eye-off'"
            [style]="'w-72 h-[86px] stroke-[4px] stroke-orange-100'"></fun-icon>
        </div>
        <p class="text-center font-sans text-h400 "
        [ngClass]="{'md:text-h600 text-eggplant-70 animate-gradientX': !blockedWindow, 'text-orange-100' : blockedWindow}">{{ adviseMsg }}</p>
        <div class="flex items-center justify-center">
          <fun-new-button
            [buttonType]="'colorFull'"
            [size]="'xl'"
            title="{{ 'bid-status.sign-now' | translate }}"
            iconPosition="right"
            icon="file-text"
            (eventClick)="controlOveralBtn(1)"
            [classExtra]="' w-auto mx-auto '"></fun-new-button>
        </div>
      </div>

      <div *ngIf="!lleidanetOpen"
        class="py-32 bg-white rounded-2xl">
        <fun-overal-message [text]="text"
          [image]="image"
          [btnList]="btnList"
          (btnEvent)="controlOveralBtn($event)"></fun-overal-message>
      </div>
    </div>
  </div>
</div>